import { CellValueUnion, cellValueFromGQL, displayDate, isNoneCell, KeyedCaseValueCalc, parseDate } from "Backend";
import { CaseInfo, CellType, CellValue, CustomPropertyType } from "generated/graphql";
import { ageAtDate } from "helpers/ageAtDate";
import { ReactNode } from "react";

export default function displayCellValue(cv: CellValue | undefined, caseInfo?: CaseInfo): ReactNode {
  if (!cv) return "";
  const v = cellValueFromGQL(cv);
  if (isNoneCell(cv)) {
    return <span />;
  } else if (cv.type === CellType.Date) {
    let date: Date | undefined;
    if (typeof v === "string") {
      date = parseDate(v);
    } else {
      date = v as Date | undefined;
    }
    const dob = parseDate(caseInfo?.dateOfBirth);
    if (date && dob) {
      return (
        <span>
          {displayDate(date)}
          {"  "}
          <span style={{ fontSize: "0.5rem", fontWeight: "bold" }}>(Age {ageAtDate(dob, date)})</span>
        </span>
      );
    } else {
      return <span>{displayDate(date)}</span>;
    }
  } else if (cv.type === CellType.MultiSelect && typeof v === "object") {
    return (v as string[]).join(", ");
  } else if (typeof v === "string") {
    return v;
  } else if (typeof v === "number") {
    return v.toString();
  } else if (typeof v === "boolean") {
    return v ? "Yes" : "No";
  } else {
    return "";
  }
}

export function displayCellValueString(cv: CellValue | undefined): string | undefined {
  if (!cv) return "";
  const v = cellValueFromGQL(cv);
  if (isNoneCell(cv)) {
    return "";
  } else if (cv.type === CellType.Date) {
    let date: Date | undefined;
    if (typeof v === "string") {
      date = parseDate(v);
    } else {
      date = v as Date | undefined;
    }
    return displayDate(date);
  } else if (cv.type === CellType.MultiSelect && typeof v === "object") {
    return (v as string[]).join(", ");
  } else if (typeof v === "string") {
    return v;
  } else if (typeof v === "number") {
    return v.toString();
  } else if (typeof v === "boolean") {
    return v ? "Yes" : "No";
  } else {
    return "";
  }
}

export function displaySimpleCellValueString(cv?: CellValueUnion): string {
  if (!cv) return "";
  if (cv instanceof Date) {
    return displayDate(cv);
  } else if (typeof cv === "number") {
    return cv.toString();
  } else if (typeof cv === "string") {
    return cv;
  } else if (typeof cv === "boolean") {
    return cv ? "true" : "false";
  } else if (Array.isArray(cv)) {
    return cv.join(", ");
  } else {
    return "";
  }
}

export function displaySimpleCellValue(cv?: CellValueUnion): ReactNode {
  if (!cv) return "";
  if (cv instanceof Date) {
    return <>{displayDate(cv)}</>;
  } else if (typeof cv === "number") {
    return <>{cv}</>;
  } else if (typeof cv === "string") {
    return <>{cv}</>;
  } else if (typeof cv === "boolean") {
    return cv ? <>true</> : <>false</>;
  } else if (Array.isArray(cv)) {
    return <>{cv.join(", ")}</>;
  }
}

export function displayCalcValue(value: KeyedCaseValueCalc): string {
  if (value.dataType === CustomPropertyType.Date) {
    const date = parseDate(value.value);
    return displayDate(date);
  } else {
    return value.value;
  }
}

export function displayCasePropertyValue(value: string | number, type: CustomPropertyType): string {
  if (type === CustomPropertyType.Date) {
    const date = parseDate(value.toString());
    return displayDate(date);
  } else {
    return value.toString();
  }
}

export interface CalcDisplayNameRanked {
  rank: number;
  ranklessDisplayName: string;
}
